import React from 'react';
import axios from 'axios';
import {Boton, Accion} from '../../comun/Index';
import Nuevo from './Nuevo';

class Listado extends React.Component {
  constructor(props) {
    super(props);
    this.state={ }
  }

  render(){
    const {areas} = this.props;
    return(
      <div className="Lista">
        {areas.map((item, index) => {
          return(
            <div
              key={index}
              className="Item"
              style={{backgroundColor:index%2===1?'#e3e3e3':'#f0f0f0'}}
            >
              <div className="Detalles">
                <div style={{display:'flex', flexDirection:'row', alignItems:'flex-end'}}>
                  {item.nombre}
                </div>
                <div className="Acciones">
                  <Accion
                    icono="edit"
                    ayuda="Editar"
                    backgroundColor="#00a5e5"
                    disabled={true}
                    onClick={() => this.props.editar(index)}
                  />
                </div>
              </div>
            </div>
          )
        })}
      </div>
    );
  }
}

const getAreas = function(){
  return new Promise(function(resolve, reject) {
    const url = localStorage.getItem('apiUrl') + '/areas/todos/'
    const config = {headers:{authorization:sessionStorage.getItem('token')}};
    axios.get(url, config)
    .then((res) => {
      if (res.data.status === "ok"){
        resolve(res.data.areas)
      } else {
        reject(res.data.error)
      }
    })
    .catch((error) => reject(error))
  });
}

export default class Usuarios extends React.Component {
  constructor(props) {
    super(props);
    this.state={
      areas:[],
      showModal:false,
      datosModal:{}
    }
  }

  componentDidMount(){
    this.actualizar();
  }



  async actualizar(){
    getAreas()
    .then((areas) => this.setState({areas}))
    .catch((error) => {
      console.log(error);
      alert("Ocurrió un error");
    })
  }

  nuevo(){
    this.setState({datosModal:{},showModal:true});
  }

  // editar(index){
  //   this.setState({datosModal:this.state.usuarios[index]});
  //   this.setState({showModal:true});
  // }

  guardar(datos){
    const url = localStorage.getItem('apiUrl') + '/areas/admin/';
    const config = {headers:{authorization:sessionStorage.getItem('token')}};
    axios.post(url, datos, config)
    .then((res) =>{
      if (res.data.status === "ok"){
        this.setState({showModal:false,datosModal:{}});
        this.actualizar();
      } else {
        alert(res.data.error);
      }
    })
    .catch((err) => {
      console.log(err);
    })
  }

  render(){
    const {showModal, datosModal, areas} = this.state;
    return(
      <div className="TramitesTodo">
        {showModal &&
          <Nuevo
            datos={datosModal}
            salir={() => {window.scrollTo(0,0);this.setState({showModal:false,datosModal:{}})}}
            guardar={(datos) => {window.scrollTo(0,0);this.guardar(datos)}}
          />
        }
        <h3>Áreas</h3>
        <Listado
          areas={areas}
          editar={(index) => {window.scrollTo(0,0);this.editar(index)}}
        />
        <Boton
          backgroundColor="#00a5e5"
          titulo="Nuevo"
          onClick={() => {window.scrollTo(0,0);this.nuevo()}}
        />
      </div>
    );
  }
}
